"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = require("react");

var _themeUi = require("theme-ui");

var _Button = _interopRequireDefault(require("../Button/Button"));

var _CardActions = _interopRequireDefault(require("../Card/CardActions"));

var _CardContent = _interopRequireDefault(require("../Card/CardContent"));

var _CardHeader = _interopRequireDefault(require("../Card/CardHeader"));

var _CardHeaderAvatar = _interopRequireDefault(require("../Card/CardHeaderAvatar"));

var _CardHeaderTitle = _interopRequireDefault(require("../Card/CardHeaderTitle"));

var _ChartKey = _interopRequireDefault(require("../ChartKey/ChartKey"));

var _ChartKeyItem = _interopRequireDefault(require("../ChartKey/ChartKeyItem"));

var _DotMatrixChart = _interopRequireDefault(require("../DotMatrixChart/DotMatrixChart"));

var _Heading = _interopRequireDefault(require("../Heading/Heading"));

var _Paragraph = _interopRequireDefault(require("../Paragraph/Paragraph"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var EventFeedItemFeedback = function EventFeedItemFeedback(_ref) {
  var title = _ref.title,
      authorAvatarUrl = _ref.authorAvatarUrl,
      subtitle = _ref.subtitle,
      learningObjective = _ref.learningObjective,
      reflectionPrompt = _ref.reflectionPrompt,
      feedbackData = _ref.feedbackData,
      feedbackCategories = _ref.feedbackCategories,
      showIndicator = _ref.showIndicator,
      onClickReflect = _ref.onClickReflect,
      props = _objectWithoutPropertiesLoose(_ref, ["title", "authorAvatarUrl", "subtitle", "learningObjective", "reflectionPrompt", "feedbackData", "feedbackCategories", "showIndicator", "onClickReflect"]);

  return (0, _themeUi.jsx)("div", _extends({}, props, {
    sx: {
      overflow: 'hidden'
    }
  }), (0, _themeUi.jsx)(_CardHeader["default"], null, (0, _themeUi.jsx)(_CardHeaderAvatar["default"], {
    url: authorAvatarUrl,
    showIndicator: showIndicator
  }), (0, _themeUi.jsx)(_CardHeaderTitle["default"], {
    title: title,
    subtitle: subtitle
  })), (0, _themeUi.jsx)(_CardContent["default"], {
    variant: "avatar",
    sx: _extends({}, feedbackData.length > 0 && {
      mb: [3, 3]
    })
  }, learningObjective ? (0, _themeUi.jsx)(_react.Fragment, null, (0, _themeUi.jsx)(_Heading["default"], {
    as: "h6",
    variant: "subtitle"
  }, "Students are learning to..."), (0, _themeUi.jsx)(_Paragraph["default"], {
    sx: {
      mt: 1
    }
  }, "\u201C", learningObjective, "\u201D")) : null, reflectionPrompt ? (0, _themeUi.jsx)(_react.Fragment, null, (0, _themeUi.jsx)(_Heading["default"], {
    as: "h6",
    variant: "subtitle"
  }, "Reflection prompt:"), (0, _themeUi.jsx)(_Paragraph["default"], {
    sx: {
      mt: 1,
      mb: 5
    }
  }, "\u201C", reflectionPrompt, "\u201D")) : null, feedbackData.length > 0 ? (0, _themeUi.jsx)(_react.Fragment, null, (0, _themeUi.jsx)(_DotMatrixChart["default"], {
    items: feedbackData
  }), (0, _themeUi.jsx)(_ChartKey["default"], {
    sx: {
      mt: 2
    }
  }, feedbackCategories.map(function (item) {
    return (0, _themeUi.jsx)(_ChartKeyItem["default"], {
      key: item.label,
      color: item.color,
      sx: {
        mb: 2,
        mx: 2
      }
    }, item.label);
  }))) : (0, _themeUi.jsx)(_Paragraph["default"], {
    sx: {
      fontStyle: 'italic',
      color: 'textMediumEmphasis'
    }
  }, "No student feedback received")), (0, _themeUi.jsx)(_CardActions["default"], {
    variant: "avatar",
    sx: {
      borderTopStyle: 'none',
      pt: 0
    }
  }, onClickReflect && (0, _themeUi.jsx)(_Button["default"], {
    onClick: onClickReflect,
    variant: "text"
  }, "Reflect on feedback")));
};

EventFeedItemFeedback.propTypes = {
  title: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]).isRequired,
  subtitle: _propTypes["default"].string,
  authorAvatarUrl: _propTypes["default"].string,
  learningObjective: _propTypes["default"].string,
  reflectionPrompt: _propTypes["default"].string,
  feedbackData: _propTypes["default"].array,
  feedbackCategories: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string,
    color: _propTypes["default"].string
  })),
  showIndicator: _propTypes["default"].bool,
  onClickReflect: _propTypes["default"].func
};
EventFeedItemFeedback.defaultProps = {
  showIndicator: false,
  feedbackData: [],
  feedbackCategories: []
};
var _default = EventFeedItemFeedback;
exports["default"] = _default;